/**
 * Change button disability if input has value
 * @param {HTMLInputElement} input
 */
function handleDiscountButtonDisability(input) {
	const fieldset = getFieldset(input);
	const button = fieldset.querySelector('button.check-discount-code');
	button.disabled = input.value.trim().length === 0;
}

/**
 * Check if input has valid discount code
 * @param {HTMLInputElement} input
 * @return {Promise<boolean>}
 */
async function validateDiscountCode(input) {
	if (!input) {
		throw new Error('no input');
	}
	const fieldset = getFieldset(input);
	const form = input.closest('form.contract-form');
	const formData = getFormData(form);
	const code = input.value.trim();
	if (code.length === 0) return true;

	try {
		removeMessage(input);
		fieldset.classList.add('loading');
		const token = await request_captcha('check_discount_code');
		const dataObject = {
			'form-id': formData['form-id'] ?? '',
			'discount-code': code,
			token
		};

		const json = await fetch('/wp-json/contract-form/check-discount-code', {
			method: 'POST',
			body: JSON.stringify(dataObject),
			headers: {
				'Content-Type': 'application/json',
			}
		}).then((response) => response.json());

		if (!json?.success) {
			throw new Error(json?.message ?? 'Wystąpił błąd.')
		}

		addSuccess(input, json?.message ?? 'Ten kod jest poprawny.');
		return true;
	} catch (error) {
		addError(input, error.message)
		return false;
	} finally {
		fieldset.classList.remove('loading');
	}
}
